<!-- <!DOCTYPE html>
<html>

<head>
    <title>LM</title>
</head> -->

<!-- <body> -->
<div class="modal-body col-sm-12 form-group">
    @if (true) {
    <form [formGroup]="ADDUserMaster" (ngSubmit)="onUserMasterFormSubmit(ADDUserMaster.value)">

        <div class="card">
            <div class="card-body">

                <div class="row">

                    <!-- ================= EMPLOYEE DETAILS ================= -->
                    <div class="col-12 col-md-6">
                        <h6 class="app-heading mb-3">Employee Details</h6>

                        <div class="form-group">
                            <label class="form-label">Employee Name <span class="text-danger">*</span></label>
                            <input class="form-control" formControlName="UserName" type="text" placeholder="Enter Name">
                            @if (f.UserName.touched && f.UserName.invalid) {
                                @if (f.UserName.errors.required) {
                                <div class="text-danger">
                                    <small>Name is required.</small>
                                </div>
                                }
                            }
                        </div>

                        <div class="form-group">
                            <label class="form-label">Email  <span class="text-danger">*</span> </label>
                            <input class="form-control" formControlName="email" type="text"
                                placeholder="email i.e abc@abc.com" [class.is-invalid]="submitted && f.email.errors">

                            @if (f.email.touched && f.email.invalid) {
                            <div class="text-danger">
                                <small>Email must be a valid email address</small>
                            </div>
                            }
                        </div>

                        <div class="form-group">
                            <label class="form-label">Mobile Number <span class="text-danger">*</span> </label>
                            <input class="form-control" formControlName="MobileNumber" type="number"
                                placeholder="Enter Mobile">
                            @if (f.MobileNumber.touched && f.MobileNumber.invalid) {
                                @if (f.MobileNumber.errors?.required) {
                                <div class="text-danger">
                                    <small>Mobile is Required.</small>
                                </div>
                                }
                            }
                        </div>

                        <div class="form-group">
                            <label class="form-label">Alternate Phone</label>
                            <input class="form-control" formControlName="AlternateMobile" type="number"
                                placeholder="Enter Alternate Mobile">
                        </div>

                        <div class="form-group">
                            <label class="form-label">
                                <a [href]="RouteGMDesignation" target="_blank">Designation </a>
                            </label>
                            <ng-select [items]="Designation" bindLabel="MainDescr" bindValue="hdID"
                                formControlName="Designation" [clearable]="false" placeholder="Select Designation">
                                <ng-option [value]="'0'">Select Designation</ng-option>
                            </ng-select>
                        </div>

                        <div class="form-group">
                            <label class="form-label">
                                <a [href]="RouteUserMaster" target="_blank">Manager L1</a>
                            </label>
                            <ng-select [items]="User" bindLabel="name" bindValue="id1" formControlName="Manager"
                                [clearable]="false" placeholder="Select Manager">
                                <ng-option [value]="'0'">Select Manager</ng-option>
                            </ng-select>
                        </div>

                        <div class="form-group">
                            <label class="form-label">
                                <a [href]="RouteUserMaster" target="_blank">Manager L2</a>
                            </label>
                            <ng-select [items]="User" bindLabel="name" bindValue="id1" formControlName="ManagerL2"
                                [clearable]="false" placeholder="Select Manager">
                                <ng-option [value]="'0'">Select Manager</ng-option>
                            </ng-select>
                        </div>

                        <div class="form-group">
                            <label class="form-label">Status</label><br>
                            <label class="radio-inline me-3">
                                <input type="radio" formControlName="Status" value="1"> Active
                            </label>
                            <label class="radio-inline">
                                <input type="radio" formControlName="Status" value="0"> Locked
                            </label>
                        </div>
                    </div>

                    <!-- ================= ACCOUNT DETAILS ================= -->
                    <div class="col-12 col-md-6">
                        <h6 class="app-heading mb-3">Account Details</h6>

                        <div class="form-group">
                            <label class="form-label">Login Name <span class="text-danger">*</span> </label>
                            <input class="form-control" formControlName="loginName" type="text"
                                placeholder="Enter Login Name">
                            @if (f.loginName.touched && f.loginName.invalid) {
                                @if (f.loginName.errors?.required) {
                                <div class="text-danger">
                                    <small>Login Name is required.</small>
                                </div>
                                }
                            }
                        </div>

                        <div class="form-group">
                            <label class="form-label">Functional Role <span class="text-danger">*</span> </label>
                            <ng-select [items]="Role" bindLabel="SubDescr" bindValue="SubID"
                                formControlName="FunctionalRole" [clearable]="false" placeholder="Select Role">
                                <ng-option [value]="'0'">Select Role</ng-option>
                            </ng-select>
                            @if (f.FunctionalRole.touched && f.FunctionalRole.invalid) {
                                @if (f.FunctionalRole.errors?.required) {
                                <div class="text-danger">
                                    <small>Functional Role is required.</small>
                                </div>
                                }
                            }
                        </div>

                        <div class="form-group">
                            <label class="form-label">
                                <a [href]="RouteCompanyMaster" target="_blank">Company <span class="text-danger">*</span> </a>
                            </label>
                            <ng-select [items]="CompanyList" bindLabel="Name" bindValue="ID" formControlName="Company"
                                [multiple]="true" [clearable]="false" [closeOnSelect]="false"
                                placeholder="Select Company">
                            </ng-select>
                            @if (f.Company.touched && f.Company.invalid) {
                                @if (f.Company.errors?.required) {
                                <div class="text-danger">
                                    <small>Company is required.</small>
                                </div>
                                }
                            }
                        </div>

                        <div class="form-group">
                            <label class="form-label">
                                <a [href]="RouteGMDepartment" target="_blank">Department <span class="text-danger">*</span> </a>
                            </label>
                            <ng-select [items]="DepartmentList" bindLabel="MainDescr" bindValue="hdID"
                                formControlName="Department" [multiple]="true" [clearable]="false"
                                [closeOnSelect]="false" placeholder="Select Department">
                            </ng-select>
                            @if (f.Department.touched && f.Department.invalid) {
                                @if (f.Department.errors?.required) {
                                <div class="text-danger">
                                    <small>Department is required.</small>
                                </div>
                                }
                            }
                        </div>

                        <div class="form-group">
                            <label class="form-label">
                                <a [href]="RouteGMRegion" target="_blank">Region</a>
                            </label>
                            <ng-select [items]="Region" bindLabel="MainDescr" bindValue="hdID" formControlName="Region"
                                (change)="onRegionSelect($event)" [clearable]="false" placeholder="Select Region">
                                <ng-option [value]="'0'">Select Region</ng-option>
                            </ng-select>
                        </div>

                        <div class="form-group">
                            <label class="form-label">
                                <a [href]="RouteGMBranch" target="_blank">Branch</a>
                            </label>
                            <ng-select [items]="Branch" bindLabel="MainDescr" bindValue="hdID" formControlName="Branch"
                                [clearable]="false" placeholder="Select Branch">
                                <ng-option [value]="'0'">Select Branch</ng-option>
                            </ng-select>
                        </div>

                        <div class="form-group">
                            <label class="form-label">Type</label><br>
                            <label class="radio-inline me-3">
                                <input type="radio" formControlName="IsPaid" value="1"> Paid
                            </label>
                            <label class="radio-inline">
                                <input type="radio" formControlName="IsPaid" value="0"> UnPaid
                            </label>
                        </div>
                    </div>
                </div>


            </div>
        </div>
        <!-- ================= SUBMIT ================= -->
        <div class="row mt-4">
            <div class="col text-center">
                @if (RightsID.includes('202040001') || RightsID.includes('202040021')) {
                <button class="btn btn-primary submit-btn small" type="submit">
                    {{ ButtonCaption }}
                </button>
                }
            </div>
        </div>
        <div class="d-flex justify-content-center mt-3">
        </div>
    </form>

    }@else {
    <!-- <form #UserMaster="ngForm" [formGroup]="ADDUserMaster" (ngSubmit)="onUserMasterFormSubmit(UserMaster.value);">
        <table class="border fullwidth">
            <tr>
                <td class="col-sm-6 border" style="width:50%">
                    <b class="app-heading">Employee Details</b> <br>
                    <div class="col-sm-3"><br>Employee Name *</div>
                    <div class="col-sm-9">
                        <br> <input class="form-control" formControlName="UserName" placeholder="Enter Name"
                            name="UserName" type="text" value="">
                    </div>
                    <div class="col-sm-3"><br>Email*</div>
                    <div class="col-sm-9">
                        <br> <input class="form-control" formControlName="email" placeholder="email i.e abc@abc.com"
                            name="email" type="text" [ngClass]="{ 'is-invalid': submitted && f.email.errors }"
                            value="" />
                        <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                            <div *ngIf="f.email.errors.email">Email must be a valid email address</div>
                        </div>
                    </div>
                    <div class="col-sm-3"><br>Mobile Number*</div>
                    <div class="col-sm-9">
                        <br> <input class="form-control" formControlName="MobileNumber" placeholder="Enter Mobile"
                            name="MobileNumber" type="text" value="">
                    </div>
                    <div class="col-sm-3"><br>Alternate Phone</div>
                    <div class="col-sm-9">
                        <br> <input class="form-control" formControlName="AlternateMobile"
                            placeholder="Enter Alternate Mobile" name="AlternateMobile" type="text" value="">
                    </div>
                    <div class="col-sm-3"><br><a href="{{RouteGMDesignation}}" target="_blank">Designation</a></div>
                    <div class="col-sm-9">
                        <br>
                        <ng-select [items]="Designation" bindLabel="MainDescr" bindValue="hdID"
                            formControlName="Designation" [clearable]="false" placeholder="[Not Selected]">
                            <ng-option [value]="'0'">[Not Selected]</ng-option>
                        </ng-select>
                    </div>
                    <div class="col-sm-3"><br><a href="{{RouteUserMaster}}" target="_blank">Manager L1</a></div>
                    <div class="col-sm-9">
                        <br>
                        <ng-select [items]="User" bindLabel="name" bindValue="id1" formControlName="Manager"
                            [clearable]="false" placeholder="[Not Selected]">
                            <ng-option [value]="'0'">[Not Selected]</ng-option>
                        </ng-select>
                    </div>
                    <div class="col-sm-3"><br><a href="{{RouteUserMaster}}" target="_blank">Manager L2</a></div>
                    <div class="col-sm-9">
                        <br>
                        <ng-select [items]="User" bindLabel="name" bindValue="id1" formControlName="ManagerL2"
                            [clearable]="false" placeholder="[Not Selected]">
                            <ng-option [value]="'0'">[Not Selected]</ng-option>
                        </ng-select>
                    </div>
                    <div class="col-sm-3"><br>Status</div>
                    <div class="col-sm-9">
                        <br> <label class="radio-inline"><input type="radio" formControlName="Status"
                                value="1">Active</label>
                        <label class="radio-inline"><input type="radio" formControlName="Status"
                                value="0">Locked</label>
                    </div>

                </td>
                <td class="col-sm-6 border" style="width:50%"><b class="app-heading">Account Details</b> <br>
                    <div class="col-sm-3"><br>Login Name *</div>
                    <div class="col-sm-9">
                        <br> <input class="form-control" formControlName="loginName" placeholder="Enter Login Name"
                            name="loginName" type="text" value="">
                    </div>
                    <div class="col-sm-3"><br>Functional Role</div>
                    <div class="col-sm-9">
                        <br>
                        <ng-select [items]="Role" bindLabel="SubDescr" bindValue="SubID"
                            formControlName="FunctionalRole" [clearable]="false" placeholder="[Not Selected]">
                            <ng-option [value]="'0'">[Not Selected]</ng-option>
                        </ng-select>
                    </div>

                    <div class="col-sm-3"><br><a href="{{RouteCompanyMaster}}" target="_blank">Company</a></div>
                    <div class="col-sm-9">
                        <br>
                        <ng-select [items]="CompanyList" [clearable]="false" [multiple]="true" formControlName="Company"
                            bindLabel="Name" bindValue="ID" [closeOnSelect]="false" placeholder="Select Company">
                            <ng-template ng-option-tmp let-item="item">
                                {{item.Name}}
                            </ng-template>
                        </ng-select>
                    </div>
                    <div class="col-sm-3"><br><a href="{{RouteGMDepartment}}" target="_blank">Department</a></div>
                    <div class="col-sm-9">
                        <br>
                        <ng-select [items]="DepartmentList" [clearable]="false" [multiple]="true"
                            formControlName="Department" bindLabel="MainDescr" bindValue="hdID" [closeOnSelect]="false"
                            placeholder="Select Department">
                            <ng-template ng-option-tmp let-item="item">
                                {{item.MainDescr}}
                            </ng-template>
                        </ng-select>
                    </div>
                    <div class="col-sm-3"><br><a href="{{RouteGMRegion}}" target="_blank">Region</a></div>
                    <div class="col-sm-9">
                        <br>
                        <ng-select [items]="Region" bindLabel="MainDescr" bindValue="hdID" formControlName="Region"
                            (change)="onRegionSelect($event)" [clearable]="false" placeholder="[Not Selected]">
                            <ng-option [value]="'0'">[Not Selected]</ng-option>
                        </ng-select>
                    </div>
                    <div class="col-sm-3"><br><a href="{{RouteGMBranch}}" target="_blank">Branch</a></div>
                    <div class="col-sm-9">
                        <br>
                        <ng-select [items]="Branch" bindLabel="MainDescr" bindValue="hdID" formControlName="Branch"
                            [clearable]="false" placeholder="[Not Selected]">
                            <ng-option [value]="'0'">[Not Selected]</ng-option>
                        </ng-select>
                    </div>
                    <div class="col-sm-3"><br>Type</div>
                    <div class="col-sm-9">
                        <br> <label class="radio-inline"><input type="radio" formControlName="IsPaid"
                                value="1">Paid</label>
                        <label class="radio-inline"><input type="radio" formControlName="IsPaid"
                                value="0">UnPaid</label>
                    </div>
                </td>
            </tr>
            <tr>
                <td colspan="2">
                    <div class="col-sm-4"> &nbsp; </div>
                    <div class="form-group col-sm-4"
                        *ngIf="this.RightsID.includes('202040001') || this.RightsID.includes('202040021') ; then AddUserLink else AddUser">
                    </div>
                    <ng-template #AddUserLink>
                        <div class=" col-sm-4 text-center">
                            <input class="btn btn-primary" type="submit" value={{ButtonCaption}}>
                        </div>
                    </ng-template>
                    <ng-template #AddUser>
                        <div class=" col-sm-4">
                            &nbsp;
                        </div>
                    </ng-template>
                    <div class="col-sm-4"> &nbsp; </div>
                </td>
            </tr>
        </table>
    </form> -->
    }
</div>
<!-- <div class="form-group mt-2" style="display:none;">
    <div class="form-check">
        <input type="checkbox" name="autoClose" id="autoClose" class="form-check-input" checked=true
            [(ngModel)]="options.autoClose">
        <label for="autoClose">Auto close alert after three seconds</label>
    </div>

</div> -->
<!-- <div class="jumbotron p-4">
        <div class="container text-center col-sm-3 alertCss">
            <app-alert></app-alert>
            <router-outlet></router-outlet>
        </div>
    </div> -->
<!-- </body> -->

<!-- </html> -->